import { observable } from 'mobx';
import { DCInventoryRepository } from '~repositories/DCInventoryRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/StoresService';

export class GetDCInventoryUseCase {
    @observable public DCInventoryRepository: DCInventoryRepository;
    @observable public skuId: string;

    constructor(skudId: string) {
        this.skuId = skudId;
        this.DCInventoryRepository = diContainer.get(serviceNames.DCInventoryRepository);
    }

    public execute = async () => {
        return this.DCInventoryRepository.loadInventory(this.skuId);
    };
}
